import styled from "@emotion/styled";
import { useDealer } from "src/hooks/useDealer";
import { useApplication } from "../ApplicationContext";
import {
  UserAccountIcon2,
  UserAccountSelectedIcon2,
  BankIcon,
  BankSelectedIcon,
} from "src/assets/icons";
import ListMenuItem from "./ListMenuItem";

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0px;
  gap: 6px;
`;

export default function ListMenu({
  currentSection,
}: {
  currentSection: string;
}) {
  const { dealer_id } = useDealer();
  const {
    application: { application_id },
  } = useApplication();

  return (
    <ListContainer>
      <ListMenuItem
        id="overview"
        label="Overview"
        subLabel="Update key dealership information."
        icon={UserAccountIcon2}
        selectedIcon={UserAccountSelectedIcon2}
        path={`/${dealer_id}/applications/${application_id}`}
        currentSection={currentSection}
      />
      <ListMenuItem
        id="lenders"
        label="Lenders"
        subLabel="Manage dealer lenders and defaults."
        icon={BankIcon}
        selectedIcon={BankSelectedIcon}
        path={`/${dealer_id}/applications/${application_id}/lenders`}
        currentSection={currentSection}
      />
      {/*
      Temporarily hiding documents menu item.
      Ticket: https://porchpass.atlassian.net/browse/DEA-513
      <ListMenuItem
        id="documents"
        label="Documents"
        subLabel="Manage application files."
        icon={FolderIcon}
        selectedIcon={FolderSelectedIcon}
        path={`/${dealer_id}/applications/${application_id}/documents`}
        currentSection={currentSection}
      /> */}
    </ListContainer>
  );
}
